import request from '@/utils/request';
/**获取架构列表数据 */
export function structureList(data) {
  return request.post('admin/structure/list', data);
}
/**架构操作 */
export function structureOperation(data) {
  let url = data.structureId ? 'admin/structure/edit' : 'admin/structure/store';
  return request.post(url, data);
}
/**架构操作删除 */
export function deleteDepartment(data) {
  return request.post('admin/structure/delete', data);
}
/**获取账号列表数据 */
export function userList(data) {
  return request.post('admin/customer/user/list', data);
}
/**账号操作 */
export function accountOperation(data) {
  let url = data.userId ? 'admin/customer/user/edit' : 'admin/customer/user/store';
  return request.post(url, data);
}
/**账号详情 */
export function accountDetail(data) {
  return request.post('admin/user/detail', data);
}
/**账号修改状态 */
export function accountStatus(data) {
  return request.post('admin/customer/user/status', data);
}
/**账号资源 */
export function accountResources(data) {
  return request.post('admin/customer/user/resource', data);
}
/**获取临时token */
export function getTemporaryToken(data) {
  return request.post('admin/get-temporary-token', data);
}